import { useTranslation, Trans } from 'next-i18next'
import PluginsStyles from '../../styles/modules/plugins.module.scss'
import { Link } from '../i18n/Link'
import { useRouter } from 'next/router'

export default function PluginGuestMessage () {
  const { t } = useTranslation(['plugins'])
  const signup = t('detail.sign_up')
  const login = t('detail.login')
  const router = useRouter()

  return (
    <div className="py-4 py-lg-5">
      <div className={`bg-white shadow p-5 rounded text-center ${PluginsStyles.guestMessage}`}>
        <Trans i18nKey="plugins:detail.guest_information">
          <Link
            href="/sign-up"
            target="_blank"
          >
            <a>{{ signup }}</a>
          </Link>
          <Link
            href={`/login?redirect=${encodeURIComponent('plugins/' + router.query.slug)}`}
          >
            {{ login }}
          </Link>
        </Trans>
      </div>
    </div>
  )
}
